import { addEventKey } from '@softnoesis/shakebug-js';

export const logEvent = (name, value) => {
  addEventKey(name, value);
};
